<template>
    <div class="mt-3">
        <b-card title="Buat Pengumuman">
            <b-card-text>
                <form class="mt-5">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Judul</label>
                        <div class="col">
                            <input type="text" class="form-control" v-model="form.judul">
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Isi</label>
                        <div class="col">
                            <textarea class="form-control" v-model="form.isi"></textarea>
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <div class="col-lg-3 text-lg-end pt-2"></div>
                        <div class="col-lg-6">
                            <b-button class="btn-sm" variant="primary" @click="createPengumuman">Simpan</b-button>
                            <b-button class="btn-sm" variant="danger" @click="cancelAdd">Batal</b-button>
                        </div>
                    </div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                judul: '',
                isi: '',
            }
        }
    },
    created() {
        //
    },
    methods: {
        createPengumuman() {
            this.$isLoading(true)
            let uri = '/api/pengumuman'

            this.axios.post(uri, this.form).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Pengumuman Berhasil Dibuat!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })

                    this.$router.push({ name: 'konfigurasi-pengumuman' }).catch(() => { })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }

                this.$isLoading(false)
            })
        },
        cancelAdd() {
            this.$router.push('konfigurasi-pengumuman')
        }
    }
}
</script>